import React from 'react'
import PropTypes from 'prop-types'

export function IconText({ className, icon, text, textColor, iconColor }) {
  const iconMapper = {
    Article: 'article',
    'Client materials': 'article',
    Worksheets: 'picture_as_pdf',
    Chart: 'bar_chart',
    Whitepaper: 'description',
    Video: 'videocam',
    'Video series': 'videocam',
    'Video list': 'videocam',
    Podcast: 'mic',
    'CE credit': 'verified',
    Time: 'schedule',
  }

  return (
    <div
      className={`u-flex u-flexAlignItemsEnd ${className || ''}`}
      style={{ paddingTop: 2, paddingBottom: 2 }}
    >
      <span
        className={`Icon--material u-textSizeMsrp1 ${
          iconColor || 'u-textColorBrandLight'
        }`}
      >
        {iconMapper[icon] ||
          (!isNaN(icon.substring(0, 1)) ? iconMapper['Time'] : null) ||
          icon}
      </span>
      <div
        className={`u-paddingLeft1gu u-textSizeMsrm1 ${
          textColor || 'u-textColorLight'
        }`}
      >
        {text}
      </div>
    </div>
  )
}

IconText.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
  iconColor: PropTypes.string,
}
